import * as types from '../types/delegations'
import company from 'api/company'

const delegationsApi = company.delegations

export const updateExistingDelegationAct = (delegation) => ({
  type: types.UPDATE_EXISTING_DELEGATION,
  delegation,
})
export const setAllDelegationsAct = (delegations) => ({
  type: types.SET_ALL_DELEGATIONS,
  delegations,
})
export const addNewDelegationAct = (delegation) => ({ type: types.ADD_NEW_DELEGATION, delegation })
export const deleteDelegationAct = (delegation) => ({ type: types.DELETE_DELEGATION, delegation })

export function getDelegations(params) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      delegationsApi.getDelegations(params).then(({ data, status }) => {
        if (status === 200) {
          dispatch(setAllDelegationsAct(data.results))
          return resolve(data)
        }
        return reject(data)
      })
    })
  }
}

export function addNewDelegation(delegation) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      delegationsApi.addDelegation(delegation).then(({ data, status }) => {
        if (status === 200) {
          dispatch(addNewDelegationAct(data.results))
          return resolve(data)
        }
        return reject(data)
      })
    })
  }
}

export function updateDelegation(delegation) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      delegationsApi.updateDelegation(delegation).then(({ data, status }) => {
        if (status === 200) {
          dispatch(updateExistingDelegationAct(delegation))
          return resolve(data)
        }
        return reject(data)
      })
    })
  }
}

export function deleteDelegation(delegation) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      delegationsApi.deleteDelegation(delegation).then(({ data, status }) => {
        if (status === 200) {
          dispatch(deleteDelegationAct(delegation))
          return resolve(data)
        }
        return reject(data)
      })
    })
  }
}
